export function showLoadingDialog(): void {
  const dialog = PF("portalLoadingDialog");
  if (dialog instanceof PrimeFaces.widget.Dialog) {
    dialog.show();
  }
}

export function hideLoadingDialog(): void {
  const dialog = PF("portalLoadingDialog");
  if (dialog instanceof PrimeFaces.widget.Dialog) {
    dialog.hide();
  }
}
